module.exports = __webpack_public_path__ + "media/about/BreastCancerLogo-ae42892d.png";